import React, { useEffect } from 'react';
import { View, Text, Loader } from '@aws-amplify/ui-react';
import { signInWithRedirect, signOut } from 'aws-amplify/auth';

const HostedUILogin = () => {
  useEffect(() => {
    const handleLogin = async () => {
      // Capture redirect URL if present
      const params = new URLSearchParams(window.location.search);
      const redirectUrl = params.get('redirect');
      
      if (redirectUrl) {
        console.log("storing redirect URL: ", redirectUrl);
        localStorage.setItem('authRedirectUrl', redirectUrl);
      }
      
      try {
        // Redirect to Cognito hosted UI
        await signInWithRedirect();
      } catch (error) {
        console.error('Error redirecting to hosted UI:', error);
        
      }
    };
    
    handleLogin();
  }, []);
  
  return (
    <View padding="2rem" textAlign="center">
      <Loader size="large" />
      <Text marginTop="1rem">Redirecting to login page...</Text>
    </View>
  );
};

export default HostedUILogin;